<div class="message-container" [class.error-message]="message.isError" [@errorShake]="message.isError">
	<div class="message-bubble" [class.error-bubble]="message.isError">
		@if (message.isError) {
			<mat-icon class="error-icon">error</mat-icon>
		}
		<div class="message-content">
			@if (message.loadingMessage) {
				<span class="loading-dots">
					<span class="dot"></span>
					<span class="dot"></span>
					<span class="dot"></span>
				</span>
			}
			@if (!message.loadingMessage) {
				<span class="message-text">{{ message.text }}</span>
			}
		</div>

		@if (!message.loadingMessage && message.sender === "Du") {
			<button
				class="copy-btn"
				(click)="copyMessage($event)"
				[@copyPulse]="animationState"
				[class.copied-state]="copied"
				type="button"
			>
				@if (!copied) {
					<mat-icon matTooltip="{{ _lang('copy-to-inputField') }}" class="copy-icon material-symbols-rounded" @iconFade
						>move_down</mat-icon
					>
				}
				@if (copied) {
					<mat-icon class="check-icon" @iconFade>check</mat-icon>
				}
			</button>
		}
	</div>
</div>
